var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('h2',{staticClass:"v-center"},[_c('StarsIcon'),_vm._v(" "+_vm._s(_vm.$t("wallet.top_ten"))+" ")],1),_c('hr'),_vm._l((_vm.people),function(person,position){return _c('Person',{key:position,attrs:{"person":person,"position":position+1}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }